// Flags de produto lidas no build (Create React App). Padrão: desligado.
const TRUE_VALUES = new Set(["1", "true", "yes", "on", "sim"]);

const isEnabled = (value: string | undefined): boolean =>
  TRUE_VALUES.has(String(value || "").trim().toLowerCase());

/** Cadastro só com CNPJ ativo e aprovação de admin (PR #960). */
export const isCompanyRegistrationApprovalEnabled = (): boolean =>
  isEnabled(process.env.REACT_APP_COMPANY_REGISTRATION_APPROVAL_ENABLED);

/** Link público de configuração Turing, disponível apenas com valor literal true. */
export const isTuringSetupLinkEnabled = (): boolean =>
  process.env.REACT_APP_TURING_SETUP_LINK_ENABLED === "true";
